import { LoadingOverlay, Space, Stack } from '@mantine/core';
import { useContext } from 'react';
import { DndProvider } from 'react-dnd-latest';
import { HTML5Backend } from 'react-dnd-html5-backend-latest';
import { ContractContext } from '../../../Service/Context/ContractContextV2';
import ContractTextBlock from '../ContractTextBlock';
import { ContractBlockButtons } from '../../../Organismns/Contract/AddBlockButtons';
import { EventRichInput } from '../../../Organismns/tiptap/TiptapEditorInput';
import DocumentBubbleMenu from '../../../Organismns/tiptap/toolbars/BubbleMenu';
import { TiptapS } from '../../../Service/TiptapS';
import SkeletonItems from '../../../Atoms/SkeletonItems';
import ContractDocumentBlock from './ContractDocumentBlock';

const ContractContentSection = () => {
  const { loading, movingBlock, contract, savePatch, aboveBlocks, belowBlocks } = useContext(ContractContext);
  const { subject, positions } = contract ?? {};
  const isEmpty = aboveBlocks.length === 0 && belowBlocks.length === 0;

  return (
    <>
      {contract && (
        <EventRichInput
          label="Überschrift"
          value={subject ?? ''}
          patchField={async (htmlString) => {
            const res = await savePatch({ subject: htmlString });
            return res !== null;
          }}
          menu={<DocumentBubbleMenu />}
          styles={TiptapS.TextInputStyles}
        />
      )}
      <Space h="xl" />
      {loading && <SkeletonItems height={100} />}
      <DndProvider backend={HTML5Backend}>
        <Stack pos="relative" spacing={5}>
          <LoadingOverlay visible={movingBlock} overlayBlur={2} loaderProps={{ size: 'xl' }} />
          {aboveBlocks.map((textBlock, index) => (
            <ContractTextBlock key={textBlock.id} isAbove index={index} textBlock={textBlock} />
          ))}
          {positions && <ContractDocumentBlock />}
          {belowBlocks.map((textBlock, index) => (
            <ContractTextBlock key={textBlock.id} index={index} textBlock={textBlock} />
          ))}
        </Stack>
      </DndProvider>
      {isEmpty && !loading && !positions && <ContractBlockButtons isAbove withoutGap />}
    </>
  );
};

export default ContractContentSection;
